"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var date_fns_1 = require("date-fns");

var TimeBaseComponent_1 = require("./TimeBaseComponent");

var TimeUntil =
/** @class */
function (_super) {
  __extends(TimeUntil, _super);

  function TimeUntil() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TimeUntil.prototype.render = function () {
    if (!this.props.children) {
      return null;
    }

    var locale = this.state.locale;
    var startTime = new Date(this.props.children);
    var now = new Date();
    var text;

    if (date_fns_1.isAfter(now, startTime)) {
      if (date_fns_1.isAfter(date_fns_1.addHours(now, -2.5), startTime)) {
        text = "" + (date_fns_1.differenceInDays(startTime, now) > 1 ? date_fns_1.formatRelative(startTime, now, {
          locale: locale
        }) : date_fns_1.format(startTime, 'PPPp', {
          locale: locale
        }));
      } else {
        text = "started " + date_fns_1.formatDistance(startTime, now, {
          locale: locale,
          addSuffix: true
        });
      }
    } else {
      if (date_fns_1.isAfter(date_fns_1.addHours(now, 2.5), startTime)) {
        text = "starts in " + date_fns_1.formatDistance(startTime, now, {
          locale: locale
        });
      } else {
        text = "" + date_fns_1.formatRelative(startTime, now, {
          locale: locale
        });
      }
    }

    return React.createElement(React.Fragment, null, text);
  };

  return TimeUntil;
}(TimeBaseComponent_1.TimeBaseComponent);

exports.TimeUntil = TimeUntil;